import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import storePersist from '../../../../redux/storePersist';
import PageLoader from '../../../../components/PageLoader';
import SocialProfilesComponent from '../components/social-profiles/social-profiles.component';
import { deepCopy } from '../../../../common/services/common.service';
let currentChange: any = {}
const SocialProfileContainer = ({ onSubmit,cardDetailInfo }: any) => {  
  const librariesItems = storePersist?.get("library")?.current;
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [ selectedSocialProfiles, setSelectedSocialProfiles ] = useState<any>([])

  // const fetchSocialProfileQueryById= ()=>{
  //   dispatch(socialProfiles.query({
  //     url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles/query`,
  //     entity:'socialProfiles',
  //     jsonData:{
  //     Records: [
  //       {
  //         Id: parmas?.id
  //       }
  //     ]
  //   }})).then(()=>{
  //     setIsQuery(true)
  //   })
  // }

  const handleFormAttachmentItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedSocialProfiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedSocialProfiles(items);
  }

  useEffect(
    () => {
      
        if (cardDetailInfo) {
          const localSelectedSocialProfiles = addNewRow({ selectedSocialProfileArg: cardDetailInfo });
          setSelectedSocialProfiles(localSelectedSocialProfiles)
            setIsLoading(false)
            } else{
              const localSelectedSocialProfiles = addNewRow({ selectedSocialProfileArg: selectedSocialProfiles });
              setSelectedSocialProfiles(localSelectedSocialProfiles)
                setIsLoading(false) 
            }
    },
    []
  )

  const addNewRow = ({ selectedSocialProfileArg }: any) => {
    const localSelectedSocialProfile = Array.isArray(selectedSocialProfileArg)
        ? deepCopy(selectedSocialProfileArg)
        : Object.values(deepCopy(selectedSocialProfileArg));

    console.log(localSelectedSocialProfile, 'localSelectedSocialProfile');

    const newsSelectedMedia = {
        Id: 0,
        OwnerTypeId: 0,
        OwnerId: 0,
        OwnerType: '',
        Name: '',
        Description: '',
        SocialProfileTypeId: 0,
        SocialProfileUrl: ''
    };

    if (
        localSelectedSocialProfile.length === 0 ||
        localSelectedSocialProfile[localSelectedSocialProfile.length - 1]?.Name !== ''
    ) {
        localSelectedSocialProfile.push(newsSelectedMedia);
    }

    return localSelectedSocialProfile;
};
  const setCombinationSocialProfileInfo = async () => {
    let localSelectedSocialProfile = deepCopy(selectedSocialProfiles)
    localSelectedSocialProfile.splice(
      currentChange.idx,
      1,
      { ...localSelectedSocialProfile[currentChange.idx] }
    );
    localSelectedSocialProfile = addNewRow({ selectedSocialProfileArg: localSelectedSocialProfile });
    currentChange.field = 'NameDONE'
    setSelectedSocialProfiles(localSelectedSocialProfile)
  }

  useEffect(
    () => {
      if (currentChange.field === 'Name') {
        setCombinationSocialProfileInfo()
      }
    },
    [selectedSocialProfiles]
  )
  const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    selectedSocialProfiles.splice(
      selectedSocialProfiles.length - 1,
      1
    );
     onSubmit(selectedSocialProfiles)
  }
 


  return (
      <>

      {isLoading ? <PageLoader /> : 
        <SocialProfilesComponent 
        handleFormAttachmentItemChange={handleFormAttachmentItemChange}
          handleFormSubmit={handleFormSubmit}
          selectedSocialProfiles={selectedSocialProfiles}
          socialProfileType={librariesItems?.SocialProfileType}
        /> 
      } 
      </>
  )
    
  }
   
export default SocialProfileContainer;